import React from "react";
import { Field } from 'react-final-form';
import t from 'babel-plugin-yate/macro';
import { useSelector, useDispatch } from "react-redux";
import { FieldArray } from "react-final-form-arrays";
import {
  composeFormValidators,
  hasMaxLength,
  hasMinVal,
  isAlphaExtraNumeric,
  isNumberWithTwoDecimals,
  isRequired,
  isNumber,
} from '../lib/validations';
import {
  parseNumberFormField,
} from '../lib/misc';
import { getNomenclatures } from "../store/request";
import { Select } from '../components/Form/Select';
import { Input } from '../components/Form/Input';
import Icon from '../components/Icons';
import Button from '../components/Button';

const NOMENCLATURES_CATEGORY = 'category';

function Products(props) {
  const { disabled, push } = props;
  const dispatch = useDispatch();
  const productCategories = useSelector(({ request }) => request.nomenclatures[NOMENCLATURES_CATEGORY]);
  
  React.useEffect(() => {
    !productCategories && dispatch(getNomenclatures(NOMENCLATURES_CATEGORY));
  }, [productCategories, dispatch]);

  return (
    <div className="border-t py-4">
      <FieldArray name="order_data.products">
        {({ fields }) => (
          <>
            {fields.map((product, index) => (
              <div
                key={product}
                className={`rounded p-2 py-4 ${disabled ? "" : "border-b mb-4"}`}
              >
                <div className="pb-5">
                  <div className="md:flex md:flex-wrap mb-2">
                    <div className="w-full md:w-1/2 px-2 mb-2">
                      <Field
                        name={`${product}.category`}
                        label={t`Product Category`}
                        component={Select}
                        disabled={disabled}
                        validate={composeFormValidators(
                          isRequired()
                        )}
                      >
                        <option value="" disabled>{t`Choose`}</option>
                        {productCategories?.map(
                          ({ id, name }) => (
                            <option
                              key={`productCategories-select-${index}-${id}`}
                              value={name}
                            >
                              {name}
                            </option>
                          )
                        )}
                      </Field>
                    </div>
                  </div>

                  <div className="md:flex md:flex-wrap mb-2">
                    <div className="w-full md:w-1/2 px-2 mb-2">
                      <Field
                        name={`${product}.name`}
                        label={t`Product name`}
                        component={Input}
                        disabled={disabled}
                        validate={composeFormValidators(
                          isRequired(),
                          isAlphaExtraNumeric(),
                          hasMaxLength(150)
                        )}
                      />
                    </div>
                    <div className="w-full md:w-1/2 px-2 mb-2">
                      <Field
                        name={`${product}.sku`}
                        label={t`Cod produs`}
                        component={Input}
                        disabled={disabled}
                        validate={composeFormValidators(
                          isRequired(),
                          isAlphaExtraNumeric(),
                          hasMaxLength(150)
                        )}
                      />
                    </div>
                  </div>


                  <div className="md:flex md:flex-wrap mb-2">
                    <div className="w-full md:w-1/2 px-2 mb-2">
                      <Field
                        name={`${product}.quantity`}
                        label={t`Quantity`}
                        component={Input}
                        disabled={disabled}
                        type="number"
                        step="1"
                        placeholder="1"
                        parse={parseNumberFormField}
                        validate={composeFormValidators(
                          isRequired(),
                          isNumber(),
                          hasMinVal(1)
                        )}
                      />
                    </div>
                    <div className="w-full md:w-1/2 px-2 mb-2">
                      <Field
                        name={`${product}.price`}
                        label={t`Product price`}
                        component={Input}
                        disabled={disabled}
                        type="number"
                        step="0.01"
                        placeholder="9999.99"
                        parse={parseNumberFormField}
                        validate={composeFormValidators(
                          isRequired(),
                          isNumberWithTwoDecimals(),
                          hasMinVal(1)
                        )}
                      />
                    </div>
                  </div>
                </div>

                {!disabled && fields.length > 1 && (
                  <div className="text-right mr-2">
                    <button
                      type="button"
                      title={t`Remove product`}
                      className="appearance-none"
                      onClick={() => fields.remove(index)}
                    >
                      <Icon name="Delete" color="#E6492D" />
                    </button>
                  </div>
                )}
              </div>
            ))}
          </>
        )}
      </FieldArray>

      <div className="ml-4">
        <Button
          title={t`Add product`}
          icon={true}
          iconSrc={<Icon name="PlusCircle" />}
          customProps={{ type: "button", disabled }}
          iconPosition="left"
          onClick={() => {
            push("order_data.products", {});
          }}
          color="white"
          border={true}
        />
      </div>
    </div>
  )
}

export default Products;
